export const HELP_LINK_PAGE_PATH = '/help/link'
